import React, {useState, useEffect, createContext, useContext} from "react";
import { useAuth } from "../hooks/useAuth";
import { useUser } from "../hooks/useUser";
import { useLocalStorage } from "../hooks/useLocalStorage";

/* type Props = {
    children?: ReactNode;
}

type IAuthContext = {
    isLoggedIn: boolean;
    setIsLoggedIn: (newSate: boolean) => void;
    authUser: any;
    setAuthUser: (newSate: boolean) => void;
}

const initialValue = {
    isLoggedIn: false,
    setIsLoggedIn: () => { },
    authUser: null,
    setAuthUser: () => { },
}

export type AuthContextType = {
    user: UserType | null;
    login: (email: string, password: string)=> void;
    isAuthenticated: boolean;
}*/

//export const AuthContext = createContext<AuthContextType | null>(null!);

export const AuthContext = createContext(undefined);
//const AuthContext = createContext<IAuthContext>(initialValue);

/* export const useAuth = () => {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error('Something went wrong!')
    }
    return context
    //return useContext(AuthContext)
} */

//export const AuthContextProvider: React.FC<{children: ReactNode}> = ({children}: any) => {
export const AuthProvider = (props) => {
    
    //const [number, setNumber] = useState(1);
    //const [isAuthenticated, setIsAuthenticated] = useState(false);//asi lo llamaba en proyectos dockerizar/repo_dpph

    /* const [authUser, setAuthUser] = useState(null)
    const [isLoggedIn, setIsLoggedIn] = useState(false)

    const loginPrueba = () => {
        alert("Name PRUEBA");
        setIsLoggedIn(true)
    }

    const checkPrueba = () => {
        alert("check PRUEBA");
        setIsLoggedIn(true)
    } */    
    
    /* const defaultValue={
        number,
        setNumber,
    }  */
    const {login, logout, isAuthenticated, user, role, userId, token, mustChangePassword, updateMustChangePassword, isEspecial, userMunicipio, entidadId} = useAuth(); //POR AHORA acceder desde el hook useAuth
    const { getItem, removeItem } = useLocalStorage();

    const {children} = props;

    // Señal para evitar parpadeos: esperamos a que termine el chequeo inicial
    const [authReady, setAuthReady] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const ENABLE_SERVER_VERIFY = true; // Cambiar a false si no querés intentar la verificación por backend aún

        const checkAuthenticated = async () => {
            try {
                const rawToken = getItem("token");
                const rawUser = getItem("user");
                const rawRole = getItem("role");
                const rawUserId = getItem("userId");
                const rawMustChangePassword = getItem("mustChangePassword");
                const rawIsEspecial = getItem("isEspecial");
                const rawUserMunicipio = getItem("userMunicipio");
                const rawEntidadId = getItem("entidadId");

                let token = null;
                let storedUser = null;
                let storedRole = null;
                let storedUserId = null;
                let storedMustChangePassword = false;
                let storedIsEspecial = false;
                let storedUserMunicipio = null;
                let storedEntidadId = null;

                try {
                    token = rawToken ? JSON.parse(rawToken) : null;
                } catch (e) {
                    console.warn('Invalid token in storage');
                    removeItem('token');
                }
                try {
                    storedUser = rawUser ? JSON.parse(rawUser) : null;
                } catch (e) {
                    console.warn('Invalid user in storage');
                    removeItem('user');
                }
                try {
                    storedRole = rawRole ? JSON.parse(rawRole) : null;
                    console.log('🔍 authContext.jsx - storedRole leído:', storedRole);
                } catch (e) {
                    console.warn('Invalid role in storage');
                    removeItem('role');
                }
                try {
                    storedUserId = rawUserId ? JSON.parse(rawUserId) : null;
                } catch (e) {
                    console.warn('Invalid userId in storage');
                    removeItem('userId');
                }
                try {
                    storedMustChangePassword = rawMustChangePassword ? JSON.parse(rawMustChangePassword) : false;
                } catch (e) {
                    console.warn('Invalid mustChangePassword in storage');
                    removeItem('mustChangePassword');
                }
                try {
                    storedIsEspecial = rawIsEspecial ? JSON.parse(rawIsEspecial) : false;
                } catch (e) {
                    console.warn('Invalid isEspecial in storage');
                    removeItem('isEspecial');
                }
                try {
                    storedUserMunicipio = rawUserMunicipio ? JSON.parse(rawUserMunicipio) : null;
                } catch (e) {
                    console.warn('Invalid userMunicipio in storage');
                    removeItem('userMunicipio');
                }
                try {
                    storedEntidadId = rawEntidadId ? JSON.parse(rawEntidadId) : null;
                } catch (e) {
                    console.warn('Invalid entidadId in storage');
                    removeItem('entidadId');
                }

                console.log('🔍 authContext.jsx - storedUserMunicipio leído:', storedUserMunicipio);
                console.log('🔍 authContext.jsx - storedEntidadId leído:', storedEntidadId);

                if (token) {
                    if (ENABLE_SERVER_VERIFY) {
                        try {
                            const res = await fetch('/api/authentication/verify', {
                                method: 'GET',
                                headers: {
                                    'Authorization': `Bearer ${token}`,
                                    'Content-Type': 'application/json'
                                }
                            });

                            if (res.ok) {
                                // Si el backend confirma, hidratamos el contexto
                                login(storedUser, token, storedRole, storedUserId, storedMustChangePassword, storedIsEspecial, storedUserMunicipio, storedEntidadId);
                            } else {
                                // Si el backend rechaza, no autenticamos (se mantendrá isAuthenticated=false)
                                // Podés llamar a logout() si querés limpiar inmediatamente el storage
                                // logout();
                                console.warn('Token rechazado por /api/authentication/verify');
                            }
                        } catch (err) {
                            // El endpoint aún no existe: dejamos preparado, pero no bloqueamos el flujo
                            console.warn('No se pudo verificar el token. Continuando con token local...', err);
                            // Elegimos hidratar igual para mantener la UX; cuando esté el endpoint se validará en serio
                            login(storedUser, token, storedRole, storedUserId, storedMustChangePassword, storedIsEspecial, storedUserMunicipio, storedEntidadId);
                        }
                    } else {
                        // Verificación deshabilitada: confiamos en el token almacenado
                        login(storedUser, token, storedRole, storedUserId, storedMustChangePassword, storedIsEspecial, storedUserMunicipio, storedEntidadId);
                    }
                } else {
                    // No hay token en storage: aseguramos estado listo sin autenticación
                    // logout(); // opcional: limpiar cualquier rastro
                }
            } finally {
                if (isMounted) setAuthReady(true);
            }
        };

        checkAuthenticated();
        return () => { isMounted = false; };
    }, [getItem, login]);

    // Valor del contexto (incluye authReady, token, mustChangePassword y isEspecial)
    const value = { login, logout, isAuthenticated, user, role, userId, authReady, token, mustChangePassword, isEspecial, userMunicipio, entidadId } //prueba
    
    /* const cambioAuth = (auth: boolean) => {
        if(auth === false){
            setIsAuthenticated(false)
        } else {
            setIsAuthenticated(true)
        }
    } */

    return (        
        <AuthContext.Provider value={value}>{children}</AuthContext.Provider> 
    )
}

//export { AuthContextProvider};



//{/*asi da error  */}
//{/* <SessionContext.Provider value={defaultValue}>{children}</SessionContext.Provider> */}

//React.createElement(SessionContext.Provider, {value: defaultValue}, children)